import * as Swiper from "../libs/swiper";

export function testimonialsVirtualSlider() {
    let slider = $(".words-slider");
    let wrapper = $(".customer-stories-listing-slider-innit");

    let mySwiper = new Swiper(wrapper, {
        speed: 400,
        slidesPerView: 2,
        slidesPerGroup: 1,
        draggable: false,
        loop: true,
        watchOverflow: true,
        breakpoints: {
            768: {
                slidesPerView: "1",
            }

        },
        navigation: {
            nextEl: wrapper.find(".swiper-button-next"),
            prevEl: wrapper.find(".swiper-button-prev")
        },
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/testimonials-virtual-slider.js